<script lang="ts" setup>
import { useState } from '#app'
import { ref, watch } from 'vue'
import type { CmsData, CmsCustomComponentType, CustomComponentValue } from '~/layers/cms/app/types/cmsTypes'
import { getByPath } from '../../utils/cmsDataHelper'

const cmsData = useState<CmsData>('cmsData')

if (!cmsData) {
  throw new Error('cmsData not provided')
}

const props = defineProps<{
  cmsDataPath: (string | number)[]
  defaults?: CmsCustomComponentType
  componentName: string
  openOptions?: boolean
  global?: boolean
}>()

const merged_values = ref<CmsCustomComponentType[]>([])

type PropsDefaults = Record<string, CustomComponentValue>

watch(() => getByPath(cmsData.value, [...props.cmsDataPath])?.component_data as CmsCustomComponentType[] | undefined, (newCmsValues) => {
  if (!newCmsValues) return
  const result: CmsCustomComponentType[] = newCmsValues.map((item) => {
    const merged: CmsCustomComponentType = { ...item }
    const defaults = props.defaults ?? {} as CmsCustomComponentType
    Object.keys(defaults).forEach((key) => {
      const defaultVal = (defaults as PropsDefaults)[key]
      merged[key] = (item[key] ? { ...defaultVal, ...item[key] } : defaultVal) as CustomComponentValue
    })
    return merged
  })
  merged_values.value = result
}, { immediate: true, deep: true })

// NIe używać jako pojedynczy custom component bo sie pierdoli xdddd
// TODO do naprawienia lmao 20.07.2026
</script>

<template>
  <div v-cms-custom-list-component:[merged_values]="{ path: [...props.cmsDataPath], componentName: props.componentName, openOptions: props.openOptions ?? true, defaultValues: defaults ?? {}, global: props.global }">
    <slot :component_values="merged_values" />
  </div>
</template>
